export interface RestResolvedUser {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
}

const toResolvedUser = (resolvedUser: any): RestResolvedUser => ({
    userId: resolvedUser.UserId,
    firstName: resolvedUser.FirstName,
    lastName: resolvedUser.LastName,
    email: resolvedUser.Email
});

export class User {
    constructor(user: any) {
        this.id = user.Id;
        this.externalUserId = user.ExternalUserId;
        this.firstName = user.FirstName;
        this.lastName = user.LastName;
        this.email = user.Email;
        this.externalStatus = user.ExternalStatus;
        this.homeOrganizationId = user.HomeOrganizationId;
        this.created = user.Created;
        this.lastLoggedIn = user.LastLoggedIn;
        this.userGroupIds = user.UserGroupIds;
        this.isLocalInSSO = user.IsLocalInSSO;
        this.isVirtual = user.IsVirtual ?? false;
        this.properties = user.Properties;

        // The API omits CreatedBy for non-virtual users and on list responses, so
        // only define the property when it is actually returned.
        if (user.CreatedBy) {
            this.createdBy = toResolvedUser(user.CreatedBy);
        }

        // Same as CreatedBy: omitted for non-virtual users and on list responses. An empty
        // array is meaningful (a VAU with no owners on record) and is preserved.
        if (user.PrincipalUsers) {
            this.principalUsers = user.PrincipalUsers.map(toResolvedUser);
        }
    }

    id: string;
    externalUserId: string;
    firstName: string;
    lastName: string;
    email: string;
    externalStatus: string;
    homeOrganizationId: string;
    created: string;
    lastLoggedIn: string;
    userGroupIds: string[];
    isLocalInSSO: boolean;
    isVirtual: boolean;
    properties: any[];
    // Read-only, omitted by the API for non-virtual users and on list responses.
    createdBy?: RestResolvedUser;
    // Read-only, omitted by the API for non-virtual users and on list responses.
    principalUsers?: RestResolvedUser[];
}
